/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { Icon } from '@icp/components';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';
import { IconButton } from '@mui/material';
import SelectElement from '../../SelectElement';

function FluentSelectAllOn24Filled() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3 6.25A3.25 3.25 0 0 1 6.25 3h9.5A3.25 3.25 0 0 1 19 6.25v9.5A3.25 3.25 0 0 1 15.75 19h-9.5A3.25 3.25 0 0 1 3 15.75zm12.28 2.78a.75.75 0 0 0-1.06-1.06L10 12.19l-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0zM6.5 20a3.25 3.25 0 0 0 2.741 1.5h7.005a5.254 5.254 0 0 0 5.254-5.254V9.241A3.25 3.25 0 0 0 19.999 6.5v9.746A3.753 3.753 0 0 1 16.246 20z"
      />
    </svg>
  );
}

function toSelectComponentProps(componentProps) {
  const {
    idListUrl,
    columnDefs,
    columns,
    supportImport,
    supportExport,
    exportColumns,
    transformKey,
    transformUrl,
    maxSizePerReq,
    AgTableProps,
    clickUseCapture,
    ...other
  } = componentProps;

  if (idListUrl) {
    delete other.dataUrl;
    other.notFoundContent = null;
  }

  return other;
}

const ACLInputUI = forwardRef(function ACLInputUI(props, ref) {
  const {
    componentLibrary,
    narrowMode,
    size,
    unit,
    ACLElementOriginalProps,
    openButtonProps,
    onSearch,
  } = props;

  const {
    keyPath,
    id,
    title,
    value,
    componentProps,
    fieldTitleProps,
    validation,
    disabled,
    readonly,
    status,
    // helpers,
    onChange,
    onTouchChanged,
  } = ACLElementOriginalProps;

  const { t } = useTranslation(['icp-components']);

  const antdProps = {
    allowClear: true,
    suffixIcon: (
      <>
        {value?.length && componentProps.multiple ? (
          <span style={{ marginRight: 4, fontSize: 'var(--font-size)' }}>
            {t('acl.selected', {
              length: value.length,
              unit,
            })}
          </span>
        ) : null}
        <Icon name="ant:down-outlined" size={12} />
      </>
    ),
  };

  const selectComponentProps = {
    lazyLoading: true,
    showSearch: true,
    ...(componentLibrary !== 'material-ui' ? antdProps : {}),
    ...toSelectComponentProps(componentProps),
    valueType: 'itemAlwaysArray',
    onSearch,
  };

  // TODO，着急上线，临时直接调用一下 SelectElement，有空完善一下统一 ACLElement 和 SelectElement 的 props，两者应该基本一样
  return (
    <>
      <SelectElement
        keyPath={keyPath}
        suppressFormControl={true}
        id={id}
        title={componentLibrary === 'material-ui' ? title : null}
        value={value}
        fieldTitleProps={fieldTitleProps}
        validation={validation}
        disabled={disabled}
        readonly={readonly}
        status={status}
        // 直接用 ACLElement props 的 onChange，不走任何 ACLElement 本身的逻辑
        onChange={onChange}
        onTouchChanged={onTouchChanged}
        componentProps={selectComponentProps}
        ref={ref}
      />
      {componentLibrary !== 'material-ui' ? (
        <Button
          {...openButtonProps}
          size={size}
          className="acl-ant-open-button"
          icon={<Icon name="ACL-select" size={16} />}
          disabled={disabled}
        >
          {!narrowMode ? t('acl.selection') : null}
        </Button>
      ) : (
        <IconButton {...openButtonProps} edge="end">
          <FluentSelectAllOn24Filled />
        </IconButton>
      )}
    </>
  );
});

ACLInputUI.propTypes = {
  componentLibrary: PropTypes.string,
  narrowMode: PropTypes.bool,
  title: PropTypes.string,
  readonly: PropTypes.bool,
  required: PropTypes.bool,
  helperText: PropTypes.string,
};

export default ACLInputUI;
